import React, { FC, useState } from 'react';
import CustomModal from '../../components/CustomModal';
import useTranslation from '../../hooks/useTranslation';
import ProjectForm from '../../components/ProjectForm/index';
import RelocationTabs from '../../components/RelocationTabs';
import { ProjectTypeModalProps } from '../../models/reusableProps/ProjectTypeModalProps';
import { useTypedSelector } from '../../store';
import { selectResponsibleOptionsList } from '../../store/users/selectors';
import {
  getBusinessUnits,
  getSelectedCountryCodes,
} from '../../store/selectData/selectors';
import { ESTABLISHMENT_TYPE } from '../../components/ProjectTypeSelect/utils';
import { selectConfidentialPermission } from '../../store/userData/selectors';
import {
  createProject,
  fetchSiteLocation,
} from '../../store/projects/actionWrapper';
import { useDispatch } from 'react-redux';
import { returnRelocationValidationSchema } from './utils';
import { selectSiteLocation } from '../../store/projects/selectors';
import { calculateTabErrors } from '../CreateNewUnitModal/utils';

const RelocationModal: FC<ProjectTypeModalProps> = ({
  visible,
  onClose,
  projectsList,
  countries,
  setActiveProject,
}) => {
  const t = useTranslation();
  const isConfidentialAllowed = useTypedSelector(selectConfidentialPermission);
  const usersList = useTypedSelector(selectResponsibleOptionsList);
  const BuList = useTypedSelector(getBusinessUnits);
  const selectedSiteLocation = useTypedSelector(selectSiteLocation);
  const dispatch = useDispatch();
  const selectedCountryCodes = useTypedSelector(getSelectedCountryCodes);
  const [selectedCountry, setSelectedCountry] = React.useState('');
  const validation = returnRelocationValidationSchema(t);
  const [formModified, setFormModified] = React.useState(false);
  const [formErrors, setFormErrors] = useState({});
  const handleCreateProject = (props) => {
    dispatch(
      createProject({
        ...props,
        establishmentType: ESTABLISHMENT_TYPE.RELOCATION,
      }),
    );
    onClose();
  };

  const onCountryChange = (country) => {
    setSelectedCountry(country.target.value);
  };

  const BuFiltered = BuList.filter(
    (bu) =>
      bu.countryId === (selectedCountry || selectedCountryCodes[0]?.countryId),
  );
  const onBUChange = (bu) => {
    dispatch(fetchSiteLocation(bu.businessUnitId || ''));
  };
  return (
    <CustomModal
      isVisible={visible}
      formModified={formModified}
      useConfirmation
      onClose={onClose}
      title={t('projectTypes.relocation')}
      children={
        <ProjectForm
          onSubmit={handleCreateProject}
          setFormModified={(isDirty) => setFormModified(isDirty)}
          country={selectedCountryCodes[0]?.countryId || ''}
          onClose={onClose}
          submitBtnTitle={t('common.create')}
          validationSchema={validation}
          selectedSiteLocation={selectedSiteLocation}
          projectType={ESTABLISHMENT_TYPE.RELOCATION}
          setFormErrors={setFormErrors}
        >
          <RelocationTabs
            projectsList={projectsList}
            countries={countries}
            setActiveProject={setActiveProject}
            usersList={usersList}
            BuList={BuFiltered}
            onCountryChange={onCountryChange}
            isConfidentialAllowed={isConfidentialAllowed}
            onBUChange={onBUChange}
            tabErrors={calculateTabErrors(formErrors, false)}
          />
        </ProjectForm>
      }
    />
  );
};

export default RelocationModal;
